import { Route } from '@angular/router';
import { SETTINGS_ROUTES } from '@clientwire/settings';

export const appRoutes: Route[] = [
  {
    path: 'login',
    loadComponent: () => import('@frontend/shared').then((m) => m.LoginComponent),
    canActivate: [() => import('@frontend/shared').then((m) => m.AntiAuthGuard)],
  },
  {
    path: 'reset-password',
    loadComponent: () => import('@frontend/shared').then((m) => m.ResetPasswordComponent),
    canActivate: [() => import('@frontend/shared').then((m) => m.AntiAuthGuard)],
  },
  {
    path: 'set-password',
    loadComponent: () => import('@frontend/shared').then((m) => m.SetPasswordComponent),
  },
  {
    path: 'settings',
    children: SETTINGS_ROUTES,
    canActivate: [() => import('@frontend/shared').then((m) => m.AuthGuard)],
  },
  {
    path: '**',
    loadComponent: () => import('@frontend/shared').then((m) => m.DashboardComponent),
    canActivate: [() => import('@frontend/shared').then((m) => m.AuthGuard)],
  },
];
